import { render, staticRenderFns } from "./StrdRL_Rows_Total.vue?vue&type=template&id=9039adfc"
import script from "./StrdRL_Rows_Total.vue?vue&type=script&lang=js"
export * from "./StrdRL_Rows_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports